export default "__VITE_ASSET__DvI1KK64__"